app.controller("CalendarEventWindowController", ["$scope", "$uibModalInstance", "params",
    function ($scope, $uibModalInstance, params) {
        $scope.calendarEvent = params.calendarEvent;
        $scope.title = params.calendarEvent.title;
        $scope.description = params.calendarEvent.description;
        $scope.faculty = params.calendarEvent.faculty;
        $scope.time = new Date(params.calendarEvent.time);
        $scope.author=params.calendarEvent.author;
        $scope.createdAt=params.calendarEvent.createdAt;

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);
